@if (state) {
  <button
    mat-icon-button
    matTooltip="{{ state.tooltip | translate }}"
    [attr.aria-label]="state.tooltip | translate">
    <mat-icon [color]="state.color">
      {{ state.icon }}
    </mat-icon>
  </button>
}
